import { AmazonConnectService } from "@amazon-connect/app";
import { AppControllerClient } from "@amazon-connect/app-controller";
import { ContactClient } from "@amazon-connect/contact";

const LOG_PREFIX = "[background-service]";

// Initialize the Amazon Connect Service
const { provider } = AmazonConnectService.init({
  onCreate: async (event) => {
    const { instanceId } = event.context;
    console.log(`${LOG_PREFIX} Service creation complete for instance:`, instanceId);

    // Reuse shared clients instead of recreating them in every handler.
    const appControllerClient = new AppControllerClient();
    const contactClient = new ContactClient();

    // Expose helpers for debugging from the browser console.
    // In DevTools, select this service's iframe as the execution context,
    // then you can run:
    //   await window.__amazonConnectService.getApps()
    //   await window.__amazonConnectService.appControllerClient.getApps()
    if (typeof window !== "undefined") {
      window.__amazonConnectService = window.__amazonConnectService || {};
      window.__amazonConnectService.appControllerClient = appControllerClient;
      window.__amazonConnectService.getApps = async () =>
        appControllerClient.getApps();
    }

    try {
      const apps = await appControllerClient.getApps();
      console.log(`${LOG_PREFIX} Active app instances in workspace:`, apps);
    } catch (error) {
      console.error("Failed to retrieve active apps:", error);
    }

    const focusLastCasesApp = async () => {
      const apps = await appControllerClient.getApps();
      console.log(`${LOG_PREFIX} Apps:`, apps);

      const casesApps = Array.isArray(apps)
        ? apps.filter((app) => {
            const name = app?.config?.name;
            const arn = app?.config?.arn;
            return (
              name === "CasesFirstPartyApp" ||
              (typeof arn === "string" && arn.includes("CasesFirstPartyApp"))
            );
          })
        : [];

      console.log(`${LOG_PREFIX} CasesApps:`, casesApps);

      if (casesApps.length < 1) {
        console.warn("No CasesFirstPartyApp instances found", {
          count: casesApps.length,
        });
        return;
      }

      const targetApp = casesApps[casesApps.length - 1]; // last Cases app
      const targetInstanceId = targetApp?.instanceId;

      if (!targetInstanceId) {
        console.warn("Target CasesFirstPartyApp instance missing instanceId", {
          targetApp,
        });
        return;
      }

      const focusedAppResp = await appControllerClient.focusApp(
        targetInstanceId
      );
      console.log(`${LOG_PREFIX} Focused last CasesFirstPartyApp instance:`, {
        instanceId: targetInstanceId,
        focusedAppResp,
      });
    };

    const handleContactForCases = async (
      contactEvent,
      allowedChannelTypes,
      label
    ) => {
      try {
        console.log(`${LOG_PREFIX} Contact ${label}:`, { contactEvent });
        console.log(`${LOG_PREFIX} Contact ID:`, contactEvent.contactId);

        const channel = await contactClient.getChannelType(
          contactEvent.contactId
        );
        console.log(`${LOG_PREFIX} Contact channel:`, channel);

        const attributes = await contactClient.getAttributes(
          contactEvent.contactId,
          "*"
        );
        console.log(`${LOG_PREFIX} Contact attributes:`, attributes);

        if (!allowedChannelTypes.includes(channel.type)) {
          console.log(
            `${LOG_PREFIX} Contact is not an allowed channel (${allowedChannelTypes.join(
              "/"
            )}), skipping`
          );
          return;
        }

        await focusLastCasesApp();
      } catch (err) {
        console.error("Error handling contact focus logic:", err);
      }
    };

    // Voice & chat: focus Cases tab when ACW starts.
    contactClient.onStartingAcw(async (contactEvent) =>
      handleContactForCases(contactEvent, ["voice", "chat"], "starting ACW")
    );

    // Task: focus Cases tab when contact is connected.
    contactClient.onConnected(async (contactEvent) =>
      handleContactForCases(contactEvent, ["task"], "connected")
    );
  },
  onDestroy: () => {
    console.log(`${LOG_PREFIX} Service destroyed. Cleaning up resources.`);
    // Add cleanup logic here
  }
});